import * as React from 'react';

type SidebarContextProps = [boolean, (isOpen: boolean) => void];

export const SidebarContext = React.createContext<SidebarContextProps>([
  false,
  () => {},
]);
